import classnames from "classnames";
import { inject } from "mobx-react";
import { createRef } from "react";
import * as React from "react";
import "./CoastHtml.style.scss";
import { isLeft } from "fp-ts/lib/Either";

import { HtmlBlockValueResolver } from "@ihr-radioedit/inferno-core";
import { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { bindHashAnchorLinks, scrollToAnchor } from "../../../../core/lib/utilities";
import { activateEmbeds } from "../../../../core/lib/embed";
import { getCoastHints } from "@ihr-radioedit/inferno-core";
import { Container } from "../../../../core/ui";
import type { Store } from "../../../../../client/stores";

@inject("store")
export class Html extends React.Component<{ block: BlockFragment; store?: Store }, {}> {
  contentRef: React.RefObject<HTMLDivElement> = createRef();

  componentDidUpdate() {
    this.props.store?.storeBlock(this.props.block);

    if (this.contentRef.current) {
      activateEmbeds(this.contentRef.current);
    }
  }

  componentDidMount() {
    bindHashAnchorLinks(this.contentRef);
    if (typeof window !== "undefined") {
      window.addEventListener(
        "load",
        () => {
          const id = window.location.href.split("#")[1];
          if (id) {
            scrollToAnchor(document.getElementById(id));
          }
        },
        { once: true },
      );
    }

    if (this.contentRef.current) {
      activateEmbeds(this.contentRef.current);
    }
  }

  render() {
    const { block, store } = this.props;
    if (!store) {
      return null;
    }
    const value = HtmlBlockValueResolver.decode(block.value);
    if (isLeft(value) || !value.right.content) {
      return null;
    }

    const coastHints = getCoastHints(block.tags);
    const addClass = classnames("component-html", coastHints);

    return (
      <Container className={addClass}>
        <div dangerouslySetInnerHTML={{ __html: value.right.content }} ref={this.contentRef} />
      </Container>
    );
  }
}
